package one.healthium.bundle.components

import androidx.compose.foundation.Image
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import ifaandroid.core.assets_bundle.generated.resources.Res
import ifaandroid.core.assets_bundle.generated.resources.allDrawableResources
import org.jetbrains.compose.resources.ExperimentalResourceApi
import org.jetbrains.compose.resources.painterResource

@OptIn(ExperimentalResourceApi::class)
@Composable
fun BundleImage(
    modifier: Modifier = Modifier,
    contentScale: ContentScale? = null,
    alignment: Alignment = Alignment.BottomCenter,
    placeholder: @Composable () -> Unit = {},
    name: String?,
) {
    if (name == null) return

    val drawable = remember(name) {
        Res.allDrawableResources[name]
    }

    // TODO show placeholder in case of error
    if (drawable != null) {
        Image(
            modifier = modifier,
            painter = painterResource(drawable),
            contentScale = contentScale ?: ContentScale.Fit,
            alignment = alignment,
            contentDescription = null,
        )
    } else {
        placeholder()
    }
}